module.exports = __webpack_public_path__ + "img/36_67.4e74b22d.png";